<template>
  <template v-for="[key, value] in options" :key="key">
    <div>
      <label><RadioField v-bind="$attrs" :value="key"/> <span>{{value}}</span></label>
    </div>
  </template>
</template>

<script>

import Attribute from "../../xmlrdb-data/Attribute"
import RadioField from "./RadioField.vue";

export default {
  name: "OptRadioField",
  components: {RadioField},
  props: {
    options: Map,
  },
  setup(props){
  }
}
</script>